<template>
  <div class="top-hero2">
    <div class="container">
      <div v-if="post" class="relative marginTop">
        <div class="w-full sm:w-8/12 mx-auto ">
          <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
            <div v-if="post.images" class="flex-shrink-0">
              <img
                class="sm:h-96 h-full w-full sm:object-cover"
                :src="post.images.post_image_path"
                alt=""
              />
            </div>
            <div class="flex-1 bg-white p-6 flex flex-col justify-between">
              <div class="flex-1">
                <div class="flex float-right align-center">
                  <a class="cursor-pointer text-gray-400 hover:text-gray-500">
                    <ShareNetwork
                      network="facebook"
                      :url="'https://www.homesby360.com/news/' + post.slug"
                      :title="post.title"
                      :description="post.description"
                      :quote="post.title"
                    >
                      <img
                        class="w-5 h-5"
                        src="https://www.cssscript.com/demo/creating-a-sticky-social-share-bar-with-css3-transitions-and-transforms/img/fb1.png"
                      />
                    </ShareNetwork>
                  </a>

                  <a
                    target="_blank"
                    href="https://www.instagram.com/homesby360"
                    class="cursor-pointer text-gray-400 hover:text-gray-500"
                  >
                    <img
                      class="ml-2 w-7 h-7 rounded-full"
                      src="https://img.icons8.com/color/48/000000/instagram-new--v1.png"
                    />
                  </a>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/in/nicolaburger"
                    class="ml-1 cursor-pointer text-gray-400 hover:text-gray-500"
                  >
                    <img
                      class="w-7 h-7 rounded-full"
                      src="https://img.icons8.com/color/48/000000/linkedin.png"
                    />
                  </a>
                </div>

                <p class="text-sm font-medium text-cyan-600">
                  <a href="#" class="hover:underline">
                    {{ post.category.name }}
                  </a>
                </p>
                <a class="block mt-2">
                  <p class="text-xl font-semibold text-gray-900">
                    {{ post.title }}
                  </p>
                  <p class="mt-3 text-base text-gray-500">
                    {{ post.description }}
                  </p>
                </a>
              </div>
            </div>

            <div class="bg-gray-50 ">
              <!--
                <v-card-actions
                  class="mb-4 bg-grid gap-2 sm:gap-8 grid-cols-1 sm:grid-cols-3"
                >
                  <v-btn rounded color="#00E676" @click="viewListing" dark
                    >View Listings</v-btn
                  >
                  <v-btn rounded color="#00E676" @click="viewRental" dark
                    >View Rentals</v-btn
                  >
                  <v-btn rounded color="#00E676" @click="contact" dark
                    >Contact 360 Real Estate</v-btn
                  >
                </v-card-actions>
                -->

              <quill-editor
                v-model="post.content"
                :options="editorOption"
                :disabled="true"
              />

              <v-list-item>
                <v-list-item-avatar>
                  <img src="../assets/360.png" alt="360 Admin" />
                </v-list-item-avatar>
                <v-list-item-content class="ml-2">
                  <v-list-item-title class="font-bold text-base">
                    {{ post.author }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ dateFormat(post.created_at) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block sm:hidden my-16"></div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "SingleNews",
  data() {
    return {
      post: "",
      editorOption: {
        theme: "bubble"
      }
    };
  },

  //insert the following code for vue-meta to work
  metaInfo() {
    return {
      title: `${this.post.title} - HomesBy360`,
      meta: [
        {
          name: "description",
          content:
            "Read and discuss " + this.post.description + " on HomesBy360"
        },
        { property: "og:title", content: this.post.title + " - HomesBy360" },
        { property: "og:site_name", content: "360 Real Estate" },
        {
          property: "og:description",
          content:
            "Read and discuss " + this.post.description + " on HomesBy360"
        },
        { property: "og:type", content: "news" },
        {
          property: "og:url",
          content: "https://www.homesby360.com/news/" + this.post.slug
        },
        {
          property: "og:image",
          content: this.post.images
            ? this.post.images.post_image_path
            : "https://homesby360.s3.amazonaws.com/360.png"
        }
      ]
    };
  },

  created() {
    this.getPost();
  },

  methods: {
    dateFormat(value) {
      const format = "YYYY-MM-DD";
      return moment(value).format(format);
    },

    getPost() {
      window.axios.get("/api/posts/" + this.$route.params.id).then(res => {
        this.post = res.data;
      });
    },

    viewListing() {
      this.$router.push({ name: "listings" });
    },
    viewRental() {
      this.$router.push({ name: "rentals" });
    },

    contact() {
      this.$router.push({ name: "Contact" });
    }
  }
};
</script>
